module.exports = __webpack_public_path__ + "img/chillo-boca-chica.4c1abc02.jpg";